/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_PROFILE, SEND_SINGLE_PURCHASE_REFERALS, UPDATE_DISCOUNT_STATUS } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { pretty } from "@vlinder-web/utils-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface SendSinglePurchaseInviteUserProps {
  presentation: any;
  section?: any;
  type?: any;
  userEmail?: any;
  partition?: any;
  discount?: any;
  committee?: any;
  sectionOptType?: any;
  notes?: any
}
export interface ISendSinglePurchaseInviteMethods extends IPluginMethodMap {
  sendSinglePurchaseInviteUser(
    args: SendSinglePurchaseInviteUserProps
  ): Promise<any>;
}

export class SendSinglePurchaseInviteUserService implements IAgentPlugin {
  readonly methods: ISendSinglePurchaseInviteMethods;

  constructor() {
    this.methods = {
      sendSinglePurchaseInviteUser:
        this.sendSinglePurchaseInviteUser.bind(this),
    };
  }

  async sendSinglePurchaseInviteUser(args: SendSinglePurchaseInviteUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args);

    let {
      presentation,
      type,
      committee,
      section,
      userEmail,
      partition,
      sectionOptType,
      discount,
      notes
    } = args;
    userEmail = userEmail.toLowerCase();
    const _data = notes ? {
      email: userEmail,
      inviteType: "Closed",
      partition: partition,
      presentation: presentation,
      sectionOptType: sectionOptType,
      sections: section,
      discount: discount ? true : false,
      inviteNote: notes,
    } : {
      email: userEmail,
      inviteType: "Closed",
      partition: partition,
      presentation: presentation,
      discount: discount ? true : false,
      sectionOptType: sectionOptType,
      sections: section,
    };
    const isValid = this.validateArgs(args);
    if (isValid?.isValidate) {
      throw new Error(isValid?.errorMessage);
    }
    try {
      if (client) {
        const res = await client.mutate({
          mutation: SEND_SINGLE_PURCHASE_REFERALS,
          variables: {
            data: {
              email: userEmail,
              inviteType: "Closed",
              partition: partition,
              presentation: presentation,
              sectionOptType: sectionOptType,
              sections: section,
              inviteNote: notes,
            },
            discount: discount ? true : false,
            addIfNotExists: true,
            invite: false,
          },
          fetchPolicy: "no-cache",
        });
        console.log(res?.data?.sendSinglePurchaseReferal?.user[0]?.id)
        if (discount) {
          const _res = await client.query({
            query: GET_MY_PROFILE,
            fetchPolicy: "network-only",
          });
          let committeeId = _res?.data?.getMyProfile?.id;
          console.log(committeeId);
          const res1 = await client.mutate({
            mutation: UPDATE_DISCOUNT_STATUS,
            variables: {
              referal: true,
              data: {
                discountId: discount,
                count: 1,
                status: "SentToMasq",
                committeeId: committeeId,
                masqId: res?.data?.sendSinglePurchaseReferal?.user[0]?.id
              }
            },
            fetchPolicy: "no-cache",
          });
          if (res1?.data) {
            return {
              ...res1?.data?.updateDiscountStatus,
            };
          }
        }
        if (res?.data) {
          return {
            ...res?.data?.sendPurchaseReferals,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private validateArgs(args: any): any {
    let message = {
      isValidate: false,
      errorMessage: ""
    }
    const {
      presentation,
      type,
      section,
      userEmail,
      partition,
      sectionOptType,
    } = args;
    if (presentation === "" || presentation === null || presentation === undefined) {
      message = {
        ...message,
        isValidate: true,
        errorMessage: "Presentation Option Type cannot be Empty",
      }
      return message;
    }
    if (partition === "" || partition === null || partition === undefined || partition === "-") {
      message = {
        ...message,
        isValidate: true,
        errorMessage: "Partition cannot be Empty",
      }
      return message;
    }
    if (sectionOptType === "" || sectionOptType === null || sectionOptType === undefined || sectionOptType === "-") {
      message = {
        ...message,
        isValidate: true,
        errorMessage: "Section Option Type cannot be Empty",
      }
      return message;
    }
    if (partition === "Default" || partition === "SpecialReserve") {
      if (section !== null) {
        message = {
          ...message,
          isValidate: true,
          errorMessage: `Section Should be Null for partition type ${partition}`,
        }
        return message;
      }
    }
    if (partition === "SectionSpecific") {
      if (section === null || section === "" || section === "-" || section === undefined) {
        message = {
          ...message,
          isValidate: true,
          errorMessage: `Section Id Should be not empty`,
        }
      }
    }
    return message;
  }
}
